export function UserRolesData() {
    return {
        name: "user_roles",
        label: "User Roles",
        primitiveType: "array",
        itemsType: "string",
    };
}

export default UserRolesData;
